<template>
  <v-tooltip
    v-if="value.length > limit" location="bottom"
  >
    <template #activator="{ props }">
      <span
        v-bind="{ ...$attrs, ...props }"
      >
        {{ value.length > limit ? (value.slice(0, (limit-3)) + '...') : value }}
      </span>
    </template>
    <span>{{ value }}</span>
  </v-tooltip>
  <span
    v-else v-bind="$attrs"
  >
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'BaseTruncatedString',

  props: {
    value: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 25,
    },
  },

};
</script>
